export default "<div class=\"sidebar\">\n    <ng-transclude></ng-transclude>\n</div>";